// extracted by mini-css-extract-plugin
export default {"DropdownItem":"MoreDropdown_DropdownItem__SKMyi","Absolute":"MoreDropdown_Absolute__yi6pO","DropdownCaret":"MoreDropdown_DropdownCaret__E-deK"};